import * as React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'

const StyledText = styled(BodyText)`
  margin-top: auto;
`

interface Props {
  availableForPurchase: boolean
  hasPrice: boolean
}

function FlashTourSoldOutOrUnavailable(props: React.PropsWithChildren<Props>) {
  const { availableForPurchase, children, hasPrice } = props
  const intl = useIntl()

  if (availableForPurchase && hasPrice) {
    return <>{children}</>
  }

  const message = availableForPurchase
    ? intl.formatMessage({
        id: 'hurggLM3P6MWrp6dHHpa',
        defaultMessage: 'unavailable',
      })
    : intl.formatMessage({
        id: 'jkD8B2NqSsBiiN-zOO3Y',
        defaultMessage: 'Sold out',
      })

  return (
    <StyledText variant="large">
      {message}
    </StyledText>
  )
}

export default FlashTourSoldOutOrUnavailable
